/**
 * Feature Flags Configuration
 *
 * Centralized feature flags for enabling/disabling functionality.
 * Flags can be controlled via environment variables (VITE_FEATURE_*).
 */

export const featureFlags = {
  /**
   * DigiD authentication integration
   * @default false - Disabled until Keycloak DigiD broker is configured
   * @env VITE_FEATURE_DIGID
   */
  DIGID_ENABLED: import.meta.env.VITE_FEATURE_DIGID === 'true',

  /**
   * Dev mode authentication bypass
   * @default false in production
   * @env VITE_DEV_AUTH_BYPASS
   */
  DEV_AUTH_BYPASS: import.meta.env.VITE_DEV_AUTH_BYPASS === 'true',
} as const;

export type FeatureFlag = keyof typeof featureFlags;

/**
 * Check if a feature is enabled
 */
export function isFeatureEnabled(flag: FeatureFlag): boolean {
  return featureFlags[flag];
}
